import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import * as React from 'react'

import AuthContext, { IAuthContext } from 'context/AuthContext'
import { IClients } from 'interfaces/IClients'
import { ICompany } from 'interfaces/ICompany'
import { IInvoices } from 'interfaces/IInvoices'

const css = require('!!raw-loader!./Auth.css').default

type Omit<ObjectType, KeysType extends keyof ObjectType> = Pick<
  ObjectType,
  Exclude<keyof ObjectType, KeysType>
>

export interface IAuthState extends Omit<IAuthContext, 'invoices' | 'clients'> {
  invoices: IInvoices
  clients: IClients
  authing: boolean
  email: string
  password: string
  error: string | null
}

class Auth extends React.Component<{}, IAuthState> {
  public state: IAuthState = {
    authing: false,
    email: '',
    password: '',
    error: null,
    user: null,
    company: null,
    invoices: {},
    clients: {},
    companies: {},
    logo: null,
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget

    this.setState({ ...this.state, [name]: value })
  }

  public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const { state } = this
    e.preventDefault()
    firebase
      .auth()
      .signInWithEmailAndPassword(state.email, state.password)
      .catch(error => {
        this.setState({
          authing: false,
          error: error.message,
        })
        // tslint:disable-next-line:no-console
        console.error(error)
      })
  }

  public componentDidMount() {
    firebase.auth().onAuthStateChanged(this.handleAuthStateChanged)
  }

  public handleAuthStateChanged = (user: firebase.User | null) =>
    this.setState({ user, company: null, loaded: false }, this.getUserData)

  public async getUserData() {
    if (!this.state.user) {
      return
    }

    const snapshot = await firebase
      .database()
      .ref(`users/${this.state.user.uid}`)
      .once('value')

    this.setState(
      state => ({
        user: { ...state.user, ...snapshot.val() },
      }),
      () => {
        this.getClients()
        this.getCompanies()
        // this.getCompany()
        this.getInvoices()
        this.getLogo()
      }
    )
  }

  public getInvoices = () =>
    this.state.user &&
    firebase
      .database()
      .ref(`/invoices/${this.state.user.uid}`)
      .on('value', snapshot =>
        this.setState({
          invoices:
            (snapshot && (snapshot.val() as IAuthState['invoices'])) || {},
        })
      )

  public getClients = () =>
    this.state.user &&
    firebase
      .database()
      .ref(`/clients/${this.state.user.uid}`)
      .on('value', snapshot =>
        this.setState({
          clients:
            (snapshot && (snapshot.val() as IAuthState['clients'])) || {},
        })
      )

  public getCompanies = () =>
    this.state.user &&
    firebase
      .database()
      .ref(`/company/${this.state.user.uid}`)
      .on('value', snapshot =>
        this.setState(
          {
            loaded: true,
            companies:
              (snapshot && (snapshot.val() as { [key: string]: ICompany })) ||
              {},
          },
          () => {
            if (
              this.state.companies &&
              Object.keys(this.state.companies).length === 1
            ) {
              this.setCompany(Object.keys(this.state.companies)[0])
            }
          }
        )
      )

  public getLogo = () =>
    this.state.user &&
    this.state.company &&
    firebase
      .storage()
      .ref(`logos/${this.state.company}.svg`)
      .getDownloadURL()
      .then((logo: string | null) => this.setState({ logo }))
      .catch((err: firebase.FirebaseError) => {
        if (err.code !== 'storage/object-not-found') {
          // tslint:disable-next-line:no-console
          console.error(err)
          alert(JSON.stringify(err))
        }
      })

  public setCompany = (company: string) =>
    this.setState({ company }, this.getLogo)

  public render() {
    const { props, state } = this

    return (
      <AuthContext.Provider
        value={{
          loaded: state.loaded,
          user: state.user,
          companies: state.companies,
          company: state.company,
          invoices: state.company ? state.invoices[state.company] || {} : {},
          clients: state.company ? state.clients[state.company] || {} : {},
          logo: state.logo,
          getLogo: this.getLogo,
          setCompany: this.setCompany,
        }}
      >
        {state.user ? (
          props.children
        ) : (
          <>
            <style>{css}</style>
            <div id="top" />
            <div id="side" />
            <div id="content">
              <div id="nav" />
              <form onSubmit={this.handleSubmit} id="login">
                <h3>Email</h3>
                <input
                  type="text"
                  name="email"
                  onChange={this.handleChange}
                  value={state.email}
                  placeholder="Email"
                />
                <h3>Lösenord</h3>
                <input
                  type="password"
                  name="password"
                  onChange={this.handleChange}
                  value={state.password}
                  placeholder="Password"
                />
                <div id="submit">
                  <input type="submit" value="logga in" />
                </div>
              </form>
            </div>
          </>
        )}
      </AuthContext.Provider>
    )
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.tsx